export function getColumns(styles, onEdit, onDelete) {
	return [
		{
			title: 'Работник',
			dataIndex: 'user',
			key: 'user',
			render: (user) =>
				user ? [user.last_name, user.name, user.father_name].filter(Boolean).join(' ') : '—',
			sorter: (a, b) => {
				const an = [a.user?.last_name, a.user?.name, a.user?.father_name].filter(Boolean).join(' ');
				const bn = [b.user?.last_name, b.user?.name, b.user?.father_name].filter(Boolean).join(' ');
				return an.localeCompare(bn, 'ru');
			}
		},
		{
			title: 'Подразделение',
			dataIndex: ['user', 'division', 'title'],
			key: 'division',
			render: (title) => title ?? '—',
			sorter: (a, b) => (a.user?.division?.title || '').localeCompare(b.user?.division?.title || '', 'ru')
		},
		{
			title: 'Профессия',
			key: 'profession',
			dataIndex: ['user', 'profession', 'title'],
			render: (text, record) =>
				(text ?? record.user?.profession?.title ?? '—')?.trim(),
			sorter: (a, b) =>
				((a.user?.profession?.title ?? '').trim())
					.localeCompare((b.user?.profession?.title ?? '').trim(), 'ru')
		},
		{
			title: 'Тип СИЗ',
			dataIndex: ['material_type', 'title'],
			key: 'material_type',
			render: (title) => title ?? '—',
			sorter: (a, b) => (a.material_type?.title || '').localeCompare(b.material_type?.title || '', 'ru')
		},
		{
			title: 'Марка',
			dataIndex: 'brand',
			key: 'brand',
			render: (brand) => brand ?? '—',
			align: 'center'
		},
		{
			title: 'Сертификат',
			key: 'sertificate',
			dataIndex: 'sertificate',
			render: (sertificate) => sertificate ?? '—',
			align: 'center'
		},
		{
			title: 'Документ',
			dataIndex: 'number_of_document',
			key: 'number_of_document',
			render: (number_of_document) => number_of_document ?? '—',
			align: 'center'
		},
		{
			title: 'Выдано',
			dataIndex: 'start_date',
			key: 'start_date',
			render: (date) => date ? new Date(date).toLocaleDateString('ru-RU') : '—',
			sorter: (a, b) => new Date(a.start_date) - new Date(b.start_date),
			align: 'center'
		},
		{
			title: 'Контроль',
			dataIndex: 'end_date',
			key: 'end_date',
			render: (date) => date ? new Date(date).toLocaleDateString('ru-RU') : '—',
			sorter: (a, b) => new Date(a.end_date) - new Date(b.end_date),
			align: 'center'
		},
		{
			title: 'Дней',
			dataIndex: 'term_to_control',
			key: 'term_to_control',
			render: (term_to_control) => term_to_control ?? '—',
			sorter: (a, b) => (a.term_to_control || 0) - (b.term_to_control || 0),
			align: 'center'
		},
		{
			title: 'Кол-во',
			dataIndex: 'quantity',
			key: 'quantity',
			render: (quantity) => quantity ?? '—',
			sorter: (a, b) => (a.quantity || 0) - (b.quantity || 0),
			align: 'center'
		},
		{
			title: 'Изменить',
			key: 'edit',
			align: 'center',
			onHeaderCell: () => ({ colSpan: 2 }),
			render: (_, record) => (
				<button
					className={styles.iconButton}
					onClick={() => onEdit(record)}
				>
					<img className={styles.iconImage} src="/icons/edit-icon.svg" alt="edit" />
				</button>
			)
		},
		{
			title: '',
			key: 'delete',
			align: 'center',
			onHeaderCell: () => ({ colSpan: 0 }),
			render: (_, record) => (
				<button
					className={styles.iconButton}
					onClick={() => onDelete(record)}
				>
					<img
						className={styles.iconImage}
						src="/icons/delete-icon.svg"
						alt="delete"
					/>
				</button>
			)
		}
	];
}
